import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateScheduledTask } from '../../redux/actions/tasks';
import { Header, Table } from 'semantic-ui-react';
import { Task } from '../../types';
import Actions from '../Common/Actions';
import EditDialog from '../Common/EditDialog';

import { ScheduledTaskColumns } from '../../constant';
import scheduledTaskFormSchema from '../Tasks/scheduledTaskFormSchema.json';
import Filters from '../Common/Filters';
import { getLocalTime, timestampColumns } from '../../utils';

const ClientTaskList = ({ tasks }: any) => {
  const [editTask, setEditTask] = useState<Task | undefined>(undefined);

  const timezone = useSelector((state: any) => state.auth.timezone);
  const useLocalTime = timezone === 'UTC' ? false : true;

  const dispatch = useDispatch();
  const [filteredTasks, setFilteredTasks] = useState(tasks);

  const handleDisable = (id: string) => {
    const [task] = tasks.filter((elem: any) => elem.id === id);
    if (task) {
      dispatch(updateScheduledTask({ ...task, Enabled: !task.Enabled }));
    }
  };

  const handleUpdate = (data: any) => {
    dispatch(updateScheduledTask({ ...editTask, ...data }));
  };

  return (
    <div>
      <Header>Scheduled Tasks</Header>

      {tasks.length > 0 && (
        <Filters
          filteredLists={filteredTasks}
          originalList={tasks}
          allowedParams={['TaskName', 'TimeZone', 'Enabled']}
          setFilteredLists={setFilteredTasks}
        />
      )}
      {editTask ? (
        <EditDialog
          update={handleUpdate}
          onClose={() => {
            setEditTask(undefined);
          }}
          formData={editTask}
          formSchema={scheduledTaskFormSchema}
        />
      ) : null}
      {tasks && tasks.length > 0 ? (
        <Table>
          <Table.Header>
            <Table.Row>
              {ScheduledTaskColumns.concat('Actions').map((header) => {
                return (
                  <Table.HeaderCell key={header}>{header}</Table.HeaderCell>
                );
              })}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {filteredTasks.map((task: any) => {
              return (
                <Table.Row key={task.id}>
                  {ScheduledTaskColumns.map((elem: any, index) => {
                    return (
                      <Table.Cell key={index}>
                        {timestampColumns.includes(elem) && useLocalTime
                          ? getLocalTime(task[elem])
                          : task[elem] === false
                          ? 'false'
                          : task[elem] && task[elem].toString()}
                      </Table.Cell>
                    );
                  }).concat(
                    <Table.Cell key={'actions' + task.id}>
                      <Actions
                        showEdit
                        showEnable
                        showDetails
                        isDisabled={!task.Enabled}
                        onDisable={() => {
                          handleDisable(task.id);
                        }}
                        onEdit={() => {
                          setEditTask(task);
                        }}
                        detailsLink={`/tasks/scheduled-task/${task.id}`}
                      />
                    </Table.Cell>
                  )}
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      ) : null}
    </div>
  );
};

export default ClientTaskList;
